import { render, staticRenderFns } from "./marketplace-highlights-header.component.vue?vue&type=template&id=3d953c5c"
import script from "./marketplace-highlights-header.component.vue?vue&type=script&lang=js"
export * from "./marketplace-highlights-header.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports